import utils from './_utilities'; //singleton instance for the page.

/*
 *  Interacts with the GPT to create and manage an ad instance.  
 */

export default (function (settings) {
  var external = {};
  var internal = {};

  internal.load = function (settings) {
    internal.adSlotSettings = {
      adId: settings.adId,
      adContainerId: settings.adContainerId,
      adSize: internal.parseAdSizeArray(settings.size),
      networkCode: settings.networkCode,
      refresh: settings.refreshWhenViewed
    };
    utils.initialize(settings);

    if (settings.testMode) {
      external.internal = internal;
    }

    utils.createStopWatch(internal.adSlotSettings.adContainerId);

    if (!internal.adSlotSettings.adSize) {
      utils.debugMode && console.log("[DoubleClick] Ad not enabled, bypassing render. AdId: " + internal.adSlotSettings.adId);
      return;
    }

    internal.renderAdSlot();
  };

  internal.parseAdSizeArray = function (sizeArray) {
    try {
      return JSON.parse(sizeArray); //parse string into array
    } catch (error) {
      console.log(error);
      return null;
    }
  };

  internal.renderAdSlot = function (targetingData) {
    utils.startTimer(internal.adSlotSettings.adContainerId, "adDisplayRequested");
    window.googletag.cmd.push(function () {
      utils.debugMode && console.log("[DoubleClick] Render requested. AdId: " + internal.adSlotSettings.adId);
      var adUnitPath = internal.adSlotSettings.networkCode + internal.adSlotSettings.adId;
      var adSlot = window.googletag.defineSlot(adUnitPath, internal.adSlotSettings.adSize, internal.adSlotSettings.adContainerId);

      if (!adSlot) {
        utils.debugMode && console.log("[DoubleClick] Unexpected null slot returned from GPT. Unable to render ad. AdId: " + internal.adSlotSettings.adId);
        return;
      }

      adSlot.addService(window.googletag.pubads());

      if (targetingData && targetingData.key) {
        adSlot.setTargeting(targetingData.key, targetingData.segments); //slot specific targeting data

        utils.debugMode && console.log("[DoubleClick] Rendering ad with personalization. AdId: " + internal.adSlotSettings.adId);
      }

      if (internal.adSlotSettings.refresh) {
        adSlot.setTargeting(utils.constants.refreshTargetingKey, utils.constants.refreshTargetingValue); //enable refresh

        utils.debugMode && console.log("[DoubleClick] Rendering ad with refresh enabled. AdId: " + internal.adSlotSettings.adId);
      }

      window.googletag.display(internal.adSlotSettings.adContainerId); //with disableInitialLoad() specified, this will prep, but not fetch the ad until refresh() called

      window.googletag.pubads().refresh([adSlot]); //fetch the ad
    });
  };

  internal.load(settings);
  return external;
});